import {
    SourceCategory,
    SourceCode,
    SourceConfig,
    SourceModalMode,
    TabType,
} from "./SourceModal.types";

import { SOURCE_ICON_BY_CODE } from "helpers/Sources/getSourceIcon";

export const SOURCE_ICONS: Record<SourceCode, string> = SOURCE_ICON_BY_CODE;

export const DEFAULT_SOURCE_ICON = "/assets/images/typeImages/default-icon.png";

export const SOURCE_CATEGORIES: Record<SourceCategory, SourceCode[]> = {
    web: ["js", "redirect"],
    crm: [
        "zoho",
        "hub",
        "salesforce",
        "dynamics",
        "freshsales",
        "monday",
        "zendesk_sell",
        "vtiger",
        "odoo",
        "pipe",
        "b24",
        "lsqrd",
    ],
    app: ["androidcapi", "ioscapi", "capi"],
    file: ["ftp", "sftp", "upload", "spreadsheet", "bigquery"],
    mmp: ["appsflyer", "adjust"],
};

export const SOURCE_CONFIG: Record<SourceCode, SourceConfig> = {
    js: {
        trackerTabs: ["overview", "settings", "update"],
        sourceTabs: ["overview", "update"],
        category: "web",
        features: {
            domains: true,
            sendInstructions: true,
            update: true,
        },
        icon: SOURCE_ICONS.js,
        displayName: "Web Site Javascript",
    },
    redirect: {
        trackerTabs: ["overview", "settings", "update"],
        sourceTabs: ["overview", "update"],
        category: "web",
        features: {
            domains: true,
            sendInstructions: true,
            update: true,
        },
        icon: SOURCE_ICONS.redirect,
        displayName: "Link Event",
    },

    zoho: {
        trackerTabs: [
            "overview",
            "history",
            "test",
            "editMapping",
            "reconnect",
        ],
        sourceTabs: ["overview", "editMapping", "reconnect"],
        category: "crm",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.zoho,
        displayName: "Zoho CRM",
    },
    hub: {
        trackerTabs: [
            "overview",
            "history",
            "test",
            "editMapping",
            "reconnect",
        ],
        sourceTabs: ["overview", "editMapping", "reconnect"],
        category: "crm",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.hub,
        displayName: "HubSpot CRM",
    },
    salesforce: {
        trackerTabs: ["overview", "history", "test", "editMapping"],
        sourceTabs: ["overview", "editMapping"],
        category: "crm",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.salesforce,
        displayName: "Salesforce CRM",
    },
    dynamics: {
        trackerTabs: ["overview", "history", "test", "editMapping"],
        sourceTabs: ["overview", "editMapping"],
        category: "crm",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.dynamics,
        displayName: "Microsoft Dynamics 365",
    },
    freshsales: {
        trackerTabs: [
            "overview",
            "history",
            "test",
            "editMapping",
            "reconnect",
        ],
        sourceTabs: ["overview", "editMapping", "reconnect"],
        category: "crm",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.freshsales,
        displayName: "Freshsales CRM",
    },
    monday: {
        trackerTabs: [
            "overview",
            "history",
            "test",
            "editMapping",
            "reconnect",
        ],
        sourceTabs: ["overview", "editMapping", "reconnect"],
        category: "crm",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.monday,
        displayName: "Monday CRM",
    },
    zendesk_sell: {
        trackerTabs: [
            "overview",
            "history",
            "test",
            "editMapping",
            "reconnect",
        ],
        sourceTabs: ["overview", "editMapping", "reconnect"],
        category: "crm",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.zendesk_sell,
        displayName: "Zendesk Sell",
    },
    vtiger: {
        trackerTabs: [
            "overview",
            "history",
            "test",
            "editMapping",
            "reconnect",
        ],
        sourceTabs: ["overview", "editMapping", "reconnect"],
        category: "crm",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.vtiger,
        displayName: "Vtiger CRM",
    },
    odoo: {
        trackerTabs: [
            "overview",
            "history",
            "test",
            "editMapping",
            "reconnect",
        ],
        sourceTabs: ["overview", "editMapping", "reconnect"],
        category: "crm",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.odoo,
        displayName: "Odoo CRM",
    },
    pipe: {
        trackerTabs: [
            "overview",
            "history",
            "test",
            "editMapping",
            "reconnect",
        ],
        sourceTabs: ["overview", "editMapping", "reconnect"],
        category: "crm",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.pipe,
        displayName: "Pipedrive CRM",
    },
    b24: {
        trackerTabs: [
            "overview",
            "history",
            "test",
            "editMapping",
            "reconnect",
        ],
        sourceTabs: ["overview", "editMapping", "reconnect"],
        category: "crm",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.b24,
        displayName: "Bitrix24",
    },
    lsqrd: {
        trackerTabs: [
            "overview",
            "history",
            "test",
            "editMapping",
            "reconnect",
        ],
        sourceTabs: ["overview", "editMapping", "reconnect"],
        category: "crm",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.lsqrd,
        displayName: "LeadSquared",
    },

    capi: {
        trackerTabs: ["overview"],
        sourceTabs: ["overview"],
        category: "app",
        features: {
            sendInstructions: true,
        },
        icon: SOURCE_ICONS.capi,
        displayName: "Offline Events",
    },
    androidcapi: {
        trackerTabs: ["overview"],
        sourceTabs: ["overview"],
        category: "app",
        features: {
            sendInstructions: true,
        },
        icon: SOURCE_ICONS.androidcapi,
        displayName: "Android App CAPI",
    },
    ioscapi: {
        trackerTabs: ["overview"],
        sourceTabs: ["overview"],
        category: "app",
        features: {
            sendInstructions: true,
        },
        icon: SOURCE_ICONS.ioscapi,
        displayName: "iOS App CAPI",
    },

    ftp: {
        trackerTabs: [
            "overview",
            "history",
            "test",
            "editMapping",
            "reconnect",
        ],
        sourceTabs: ["overview", "editMapping", "reconnect"],
        category: "file",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.ftp,
        displayName: "FTP Source",
    },
    sftp: {
        trackerTabs: [
            "overview",
            "history",
            "test",
            "editMapping",
            "reconnect",
        ],
        sourceTabs: ["overview", "editMapping", "reconnect"],
        category: "file",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.sftp,
        displayName: "SFTP Source",
    },
    upload: {
        trackerTabs: ["overview", "history", "test", "editMapping"],
        sourceTabs: ["overview", "editMapping"],
        category: "file",
        features: {
            fileUpload: true,
            mapping: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.upload,
        displayName: "File Upload",
    },
    spreadsheet: {
        trackerTabs: [
            "overview",
            "history",
            "test",
            "editMapping",
            "reconnect",
        ],
        sourceTabs: ["overview", "editMapping", "reconnect"],
        category: "file",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.spreadsheet,
        displayName: "Google Spreadsheet",
    },
    bigquery: {
        trackerTabs: ["overview", "history", "test", "editMapping", "schedule"],
        sourceTabs: ["overview", "editMapping", "schedule"],
        category: "file",
        features: {
            mapping: true,
            reconnect: true,
            history: true,
            test: true,
        },
        icon: SOURCE_ICONS.bigquery,
        displayName: "Google BigQuery",
    },

    appsflyer: {
        trackerTabs: ["overview", "editMapping"],
        sourceTabs: ["overview", "editMapping"],
        category: "mmp",
        features: {
            mapping: true,
            reconnect: true,
        },
        icon: SOURCE_ICONS.appsflyer,
        displayName: "AppsFlyer",
    },
    adjust: {
        trackerTabs: ["overview", "editMapping"],
        sourceTabs: ["overview", "editMapping"],
        category: "mmp",
        features: {
            mapping: true,
            reconnect: true,
        },
        icon: SOURCE_ICONS.adjust,
        displayName: "Adjust",
    },
    msg: {
        trackerTabs: ["overview"],
        sourceTabs: ["overview"],
        category: "mmp",
        features: {},
        icon: SOURCE_ICONS.msg,
        displayName: "Messaging",
    },
};

export const TAB_LABELS: Record<TabType, { key: string; default: string }> = {
    overview: { key: "buttons.overview", default: "Overview" },
    settings: { key: "buttons.Settings", default: "Settings" },
    update: { key: "buttons.update", default: "Update" },
    history: { key: "buttons.history", default: "History" },
    test: { key: "buttons.test", default: "Test" },
    editMapping: { key: "buttons.edit_mapping", default: "Edit Mapping" },
    schedule: { key: "buttons.schedule", default: "Schedule" },
    reconnect: { key: "buttons.reconnect", default: "Reconnect" },
};

export const getSourceIcon = (
    code: SourceCode | string | undefined,
): string => {
    if (!code) return DEFAULT_SOURCE_ICON;

    return SOURCE_ICONS[code as SourceCode] || DEFAULT_SOURCE_ICON;
};

export const getSourceConfig = (
    code: SourceCode | string | undefined,
): SourceConfig | null => {
    if (!code) return null;
    return SOURCE_CONFIG[code as SourceCode] || null;
};

export const getSourceTabs = (
    code: SourceCode | string | undefined,
    mode?: SourceModalMode,
): TabType[] => {
    const config = getSourceConfig(code);
    if (mode === "tracker") {
        return config?.trackerTabs || ["overview"];
    } else {
        return config?.sourceTabs || ["overview"];
    }
};

export const hasFeature = (
    code: SourceCode | string | undefined,
    feature: keyof SourceConfig["features"],
): boolean => {
    const config = getSourceConfig(code);
    return config?.features?.[feature] || false;
};

export const getSourceCategory = (
    code: SourceCode | string | undefined,
): SourceCategory | null => {
    const config = getSourceConfig(code);
    return config?.category || null;
};

export const getSourceDisplayName = (
    code: SourceCode | string | undefined,
    fallback?: string,
): string => {
    const config = getSourceConfig(code);
    return config?.displayName || fallback || code || "Unknown Source";
};
